import { cloneDeep } from 'lodash'
import { DEFAULT_CONTACT_LIST_ITEMS } from 'src/constants/contacts-list-item-default'
import { DEFAULT_LISTS } from 'src/constants/default-lists'

export default function () {
  return {
    listItems: {
      all: DEFAULT_CONTACT_LIST_ITEMS,
      'my-contacts': DEFAULT_CONTACT_LIST_ITEMS,
      unassigned: DEFAULT_CONTACT_LIST_ITEMS,
      unanswered: DEFAULT_CONTACT_LIST_ITEMS,
      'new-leads': DEFAULT_CONTACT_LIST_ITEMS
    },
    lists: cloneDeep(DEFAULT_LISTS),
    publicLists: [],
    columns: null,
    folders: [],
    isFiltersOpen: false,
    opened: [],
    pinned: [],
    pinnedCounts: {
      all: 0,
      'my-contacts': 0,
      unassigned: 0,
      unanswered: 0,
      'new-leads': 0
    },
    removeContact: null,
    removeContactActionType: null,
    isBulkDelete: false,
    removeFolder: null,
    removeList: null,
    removedFolder: null,
    moveDialog: {
      open: false,
      id: null,
      type: 'folder',
      target: null
    },
    createDialog: {
      open: false,
      id: null,
      type: 'list',
      target: null
    },
    isAllContactsSelected: false,
    selectedList: {
      id: 'all',
      name: 'All Contacts',
      contactCount: 0
    },
    persistedListId: null,
    shouldUpdateSelectedListContactCount: false,
    selectedStaticList: {
      id: null,
      name: '',
      type: null,
      hasEdit: 0,
      hasDelete: 0
    },
    createList: {
      name: '',
      mode: '', // from_filters, from_bulk_menu, from_folders
      type: 1,
      show_in_public_folder: false,
      open: false,
      contact_folder_id: null,
      filters: []
    },
    selectList: {
      contact_list_id: null,
      open: false,
      search_value: ''
    },
    filters: [],
    currentListFilters: {},
    contact: {},
    contactClone: {},
    changedContactProperties: [],
    changedContactAttributes: [],
    contactPhoneNumbers: [],
    conflictedContactPhoneNumbers: [],
    contactRingGroups: [],
    contactAttributes: [],
    contactAttributesClone: [],
    isSidebarCollapsed: false,
    isContactNameEditOpen: false,
    contactSelectedPhone: null,
    selectedLine: null,
    messageComposer: {
      mode: 'sms',
      sms: {
        body: '',
        phone_number: null,
        // the picked number's id; null for the contact's primary number, which the API defaults to
        contact_phone_number_id: null,
        attachments: [],
        gif_url: '',
        schedule_date: null
      },

      fax: {
        filename: ''
      },

      email: {
        subject: '',
        body: '',
        attachments: []
      },
      note: {
        body: '',
        type: 10,
        date: null,
        time: null,
        timezone: null
      }
    },
    isScheduleMessageOpen: false,
    isScheduledMessageListOpen: false,
    isAddAppointmentOpen: false,
    isAppointmentSubmitted: false,
    isAddPowerDialerOpen: false,
    isMergeContactOpen: false,
    isEnrollSequenceOpen: false,
    isAddReminderOpen: false,
    isOptoutActive: true,
    optoutText: '\nText STOP to unsubscribe.',
    changingSelectedContact: false,
    smsTemplateModal: {
      open: false,
      scope: 'user',
      template: null
    },
    search: '',
    searchedPdItem: '',
    showMenu: false,
    showContactsHeader: true,
    showContactsListSidebar: false,
    showMyContacts: false,
    showAddViewMyContacts: false,
    unsavedList: null,
    activeFolder: '',
    clearList: false,
    pinnedListsLoaded: false,
    publicListsLoaded: false,
    myListsLoaded: false,
    listContactsLoaded: false,
    previousListFilters: {},
    previouslySavedListId: null,
    previousListId: null,
    previousListPath: null,
    sequenceInfo: {
      sequence: null,
      workflow: null
    },
    sequenceInfoLoading: false,
    lineIncomingNumber: null,
    lineIncomingNumberLoading: false,
    communicationsSummary: {
      first_outbound_call: null,
      summaries: {
        inbound_calls_count: 0,
        outbound_calls_count: 0,
        inbound_texts_count: 0,
        outbound_texts_count: 0,
        total_count: 0
      }
    },
    isContactMixinUsed: false,
    isShortenedUrlRemembered: false,
    newCommunicationInprogressContactFetch: [],
    inProgressAxiosUniqueIds: [],
    propertyAuditDrawerOpen: false,
    propertyAuditDrawerContactId: null,
    propertyAuditDrawerPropertyType: 'default',
    propertyAuditDrawerProperty: '',
    propertyAuditDrawerPropertyLabel: '',
    propertyAuditDrawerCustomAttributeType: null
  }
}
